export default __webpack_public_path__ + "static/transformBackgroundImage-52fd44b7d32b460cd3f92ab5bfe1742f.png";